import React from "react";
import '../App.css';
import '../blocks/customblocks';
import '../generator/generator';
import styles from "../styles/level1.module.css"
import instrLink from "../images/level0/instrLink.png"
import L1T0 from '../toolboxes/L1T0'
import BlocklyComponent from '../Blockly';
import level1Task0 from "../solutionxml/level1Task0";
import level1Task1 from "../solutionxml/level1Task1";


const level1 = () => {
  return (
    <div className={styles.container}>
    <main>
      <h1 className={styles.title}>
        Level 1: Logic and Booleans 
      </h1>
      <br></br>
      <div className={styles.center}>
        <h3 className={styles.instructions}> Task 0: Try using =,{"<"},{">"}, and not = operators to create an expression that evaluates to TRUE, using the 'print' function to check your answer.</h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      
      toolbox = {L1T0}
      solutionXml = {level1Task0}
      >
      </BlocklyComponent>
    </div>
    <br></br>
    <div className={styles.center}>
        <h3 className={styles.instructions}> Task 1: Try using =,{"<"},{">"}, and not = operators to create an expression that evaluates to FALSE, using the 'print' function to check your answer.</h3>
      </div>
    <br></br>
    <div className={styles.right}>
      <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
        <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
      </a>
    </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      
      toolbox = {L1T0}
      solutionXml = {level1Task1}
      >
      </BlocklyComponent>
    </div>
  </main>
  </div>
  );
}
  
export default level1;